module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-06-11 at 4.40.17 PM.57b07a17.jpeg";